<template>
  <div>
    <!-- Season / Divisions / Teams / Venues / Timeslots / Schedule -->
    <!-- <Breadcrumb :model="menuItems" /> -->
    <div class="p-grid p-justify-center p-mt-2">
      <div v-if="step == -1" class="p-col">
        <h1 class="title is-2">{{ $t("welcome-lets-get-started") }}</h1>
        <p class="p-my-3">Create a League</p>
        <InputText placeholder="League Name" class="fs15" autofocus v-model="league_name" />
        <div class="p-my-3">
          <Button :label="$t('Button.continue')" @click="createLeague" />
        </div>
      </div>
      <div v-if="step == 0" class="p-col">
        <h1 class="title is-1">New Season in {{ this.$store.getters.currentLeague.name }}</h1>
        <div>
          <InputText placeholder="Season Name" class="fs15" autofocus v-model="season_name" />
        </div>
        <div class="p-my-3">
          <Button label="Create" @click="create" />
        </div>
      </div>
      <div v-else-if="step == 1" class="p-col">
        <h1 class="title is-1">Add Divisions</h1>
        <p>How many divisions?</p>
        <Dropdown
          v-model="division_count"
          @change="setDivisions"
          inputId="division-input"
          :options="count_options"
          class="fs35"
        />

        <div v-for="d in divisions" :key="d" class="p-my-2">
          <InputText v-model="d.name" />
        </div>
        <div class="p-my-3">
          <Button :label="$t('Button.continue')" @click="next" />
        </div>
      </div>
      <div v-else-if="step == 2" class="p-col">
        <h1 class="title is-1">Add Teams</h1>
        <div class="p-col-12">
          <p>How many Teams per Division?</p>
          <Dropdown v-model="team_count" @change="setTeams" :options="count_options" />
        </div>
        <div class="p-grid p-justify-center">
          <div v-for="(d, i) in divisions" :key="d.name" class="p-col">
            <div v-if="d.teams.length">
              <h3 class="title is-4">{{ d.name }}</h3>
              <div v-for="t in d.teams" :key="t" class="p-my-2">
                <InputText v-model="t.name" />
              </div>
              <div v-if="d.teams.length">
                <Button class="p-button-text" @click="addTeam(i)"> Add </Button>
                <Button class="p-button-text" @click="removeTeam(i)">
                  Remove
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div class="p-my-3">
          <Button :label="$t('Button.continue')" @click="create" />
        </div>
      </div>
      <div v-else-if="step == 3" class="p-col">
        <h1 class="title is-1">Add Venues</h1>
        <div class="p-col-12">
          <p>How many Venues exist?</p>
          <Dropdown v-model="venue_count" @change="setVenues" :options="count_options" />
        </div>
        <div v-for="v in venues" :key="v" class="p-my-2">
          <InputText v-model="v.name" />
        </div>
        <div class="p-my-3">
          <Button label="Create Season" @click="create" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "primevue/breadcrumb";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import api from "@/api";

export default {
  components: { Breadcrumb },
  data() {
    return {
      step: this.$store.getters.currentLeague ? 0 : -1,
      league_name: "",
      season_name: "",
      division_count: 2,
      venue_count: 2,
      venues: [],
      team_count: 4,
      divisions: [],
    };
  },
  computed: {
    menuItems() {
      const items = [
        {
          label: "League",
          command: event => {},
        },
        {
          label: "Season",
          command: event => {
            this.step = 0;
          },
        },
        {
          label: "Divisions",
          disabled: !this.divisions.length,
          command: event => {
            this.step = 1;
          },
        },
        {
          label: "Teams",
          disabled: !this.divisions.length,
          command: event => {
            this.step = 2;
          },
        },
        {
          label: "Venues",
          disabled: !this.venues.length,
          command: event => {
            this.step = 3;
          },
        },
        {
          label: "Timeslots",
          disabled: this.step < 4,
          command: event => {
            this.step = 4;
          },
        },
        {
          label: "Schedule",
          disabled: this.step < 5,
          command: event => {
            this.step = 5;
          },
        },
      ];
      return items;
    },
    count_options() {
      var i = 1;
      var x = [];
      while (i < 21) {
        // x.push({
        //   name: i.toString(),
        //   value: i,
        // });
        x.push(i);
        i++;
      }
      return x;
    },
  },
  methods: {
    createLeague() {
      api
        .createLeague(this.league_name)
        .then(response => {
          this.refreshLeagueInformation();
          setTimeout(() => {
            this.next();
          }, 500);
        })
        .catch(e => {
          console.log(e);
        });
    },
    create() {
      api
        .createSeason({
          league_id: this.$store.getters.currentLeague ? this.$store.getters.currentLeague.id : {},
          name: this.season_name,
          divisions: this.divisions,
          venues: this.venues,
        })
        .then(response => {
          console.log("Success", response);
          var ls = response;
          console.log("new League and season", ls.data.league, ls.data.season);
          this.setCurrentLeagueSeasonId(ls.data.league.id, ls.data.season.id);
          setTimeout(() => {
            this.goRouter(`/venues/new`);
          }, 500);
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
    next() {
      if (this.step == 0) {
        this.setDivisions();
      } else if (this.step == 1) {
        this.setDivisions();
        this.setTeams();
      } else if (this.step == 2) {
        // this.setTeams();
        this.setVenues();
      }

      this.step++;
    },
    removeTeam(index) {
      this.divisions[index].teams.pop();
    },
    addTeam(index) {
      var d = this.divisions[index].teams;
      d.push({
        name: "Team " + (d.length + 1),
      });
    },
    setVenues: function() {
      if (this.venue_count < this.venues.length) {
        this.venues.splice(this.venue_count, this.venues.length - this.venue_count);
      } else {
        var i = 1;
        while (i <= this.venue_count) {
          if (!this.venues[i - 1]) {
            this.venues.push({ name: "Venue " + i });
          }
          i++;
        }
      }
    },
    setDivisions: function() {
      console.log("SetDivisions", this.division_count, this.divisions.length);
      if (this.division_count < this.divisions.length) {
        this.divisions.splice(this.division_count, this.divisions.length - this.division_count);
      }
      var i = 1;
      while (i <= this.division_count) {
        if (!this.divisions[i - 1]) {
          this.divisions.push({ name: "Division " + i, teams: [] });
        }
        i++;
      }
    },
    setTeams: function() {
      console.log("setTeams");
      var i = 1;
      this.divisions.forEach(d => {
        var teams = d.teams;
        if (this.team_count < teams.length) {
          console.log("splice at ", this.team_count - 1, this.team_count - 1 - teams.length);
          teams.splice(this.team_count, teams.length - this.team_count);
        }
        var j = 1;
        while (j <= this.team_count) {
          if (!teams[j - 1]) {
            teams.push({ name: "Team " + j });
          }
          j++;
        }
      });
    },
  },
  created() {},
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
#division-input {
  font-size: 3.5em;
}
</style>
